import { render } from "./company_m_Hatsurei.vue?vue&type=template&id=2aa27a66"
import script from "./company_m_Hatsurei.vue?vue&type=script&lang=js"
export * from "./company_m_Hatsurei.vue?vue&type=script&lang=js"

import "./company_m_Hatsurei.vue?vue&type=style&index=0&id=2aa27a66&lang=css"

import exportComponent from "/codebuild/output/src327471177/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__